/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Common_Continue1Inputs */

const en_coinvestments_common_continue1 = /** @type {(inputs: Coinvestments_Common_Continue1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Coinvestments_Common_Continue1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_common_continue1 = /** @type {((inputs?: Coinvestments_Common_Continue1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Common_Continue1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_common_continue1(inputs)
});
export { coinvestments_common_continue1 as "coInvestments_common_continue" }